import notificationService from '@/services/notification/notification.service'
import isNil from 'ramda/src/isNil'

export function handleListResponse(response) {
  const xTotalCount = response.headers['x-total-count']
  if (isNil(xTotalCount)) {
    log.error('x-total-count header must be defined, current value', response.headers['x-total-count'])
    notificationService.error('x-total-count header must be defined')
  }
  const totalItems = Number(xTotalCount) || 0
  return {
    items: response.data,
    totalItems
  }
}

export function handleSingleDataResponse(response) {
  return response.data
}

export function handleError(error, ignoredHttpStatuses = []) {
  const status = error.response.status
  const isHandleErrorAllowed = !ignoredHttpStatuses.includes(status)

  if (isHandleErrorAllowed) notificationService.error(error)

  return Promise.reject(error)
}
